var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 0.833405C25.3732 0.833405 28.1287 1.97477 30.1604 4.00641C32.192 6.03806 33.3334 8.79356 33.3334 11.6667C33.3334 14.5399 32.192 17.2954 30.1604 19.3271C28.1287 21.3587 25.3732 22.5001 22.5 22.5001C19.6269 22.5001 16.8714 21.3587 14.8397 19.3271C12.8081 17.2954 11.6667 14.5399 11.6667 11.6667C11.6667 8.79356 12.8081 6.03806 14.8397 4.00641C16.8714 1.97477 19.6269 0.833405 22.5 0.833405ZM22.5 27.9167C34.4709 27.9167 44.1667 32.7647 44.1667 38.7501V44.1667H0.833374V38.7501C0.833374 32.7647 10.5292 27.9167 22.5 27.9167Z",
    fill: "#314A72"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.da3467151ca78b43359620c0d6da0c6e.svg";
export { ForwardRef as ReactComponent };